import React, { CSSProperties, FC, useEffect, useState } from 'react'
import classNamesBind from 'classnames/bind'
import css from './styles.module.scss'
import { useAppStateSelector } from '@dashboard/hooks/useAppStateSelector'
import { ToastMessage } from '@dashboard/lib/types'
import PieceOfToast from './PieceOfToast'

interface OwnProps {}

const classNames = classNamesBind.bind(css)
const NAV_HEIGHT = 96
const MIN_TOP_MARGIN = 32

const Toast: FC<OwnProps> = ({}: OwnProps) => {
  const { toastMessages } = useAppStateSelector(state => state.user)
  const [top, setTop] = useState(NAV_HEIGHT)
  const style: CSSProperties = {
    top: `${top}px`,
  }

  // Functions
  const handleScroll = () => {
    const amount = Math.max(MIN_TOP_MARGIN, NAV_HEIGHT - window.scrollY)

    if (amount === top) return

    setTop(amount)
  }

  // Effects
  useEffect(() => {
    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [top])

  // Partials
  const renderToastMessage = (toast: ToastMessage) => {
    return <PieceOfToast key={`key-${toast.id}`} toast={toast} />
  }

  return (
    <div className={classNames('container')} style={style}>
      {toastMessages.map(renderToastMessage)}
    </div>
  )
}

export default Toast
